module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADVSURBVEhL5ZQxCsJAFEQDOYeVeFIRe28gWmihlxIUxUIvkDhDXqX+7MaIoD74sMvOm18lxX9QVdVQs9KcGJ+HPPfDRS6t72BR/yUqWdP5gN+IdUNuKXms2TVVMc44q2OJnkbCtNHzkTNBT6PwHi8bO+hpFD7iZSPngJ5G4RleNnbQ21FwpDnjZWPHLjUxCm1xOiN3Q02MQlfyr3ChJuYTC5aEOyN3QU2MQk//PSnk+IseUNOOg5q5JfwQip3NK2+Dzprr+6H/yxbQGULsdegJIfazFMUNEPtpoyITSEoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-oak-tree/light/24.png
// module id = 2280
// module chunks = 2